import { RegionData } from '@/editor/data/region/Region';
import { EFaceType } from '../type';
import { ContourFaceModel } from './faceModel/contourFaceModel';
import { EEntityType, EFaceSide } from '@/editor/types';
import { EContainerType } from '@/editor/types/entity';
import { EFaceDataBaseType } from '@/editor/data/face/face';
import { getPathFromEdges } from '@/editor/utils/edge';
import { IPoint2d } from '@/editor/math/IPoint2d';
import { ArcSeg2d } from '@/editor/math/arcSeg2d';
import { isArc } from '@/editor/utils/arc';

type IRegionModelData = Pick<RegionData, 'id' | 'offGround' | 'corePathInfos' | 'coreHoleInfos' | 'materialInfo'>;

function translateRegionToBaseData(regionData: IRegionModelData) {
  return {
    contour: getPathFromEdges(regionData.corePathInfos),
    offGround: regionData.offGround
  };
}

class RegionModel extends ContourFaceModel {
  constructor(regionData: IRegionModelData) {
    super({ id: regionData.id });

    // 覆盖face中的数据
    this.model.userData.type = EEntityType.Region;
    this.model.userData.containerType = EContainerType.entity;
    this.model.userData.entityId = this._id;

    this.createRegionModel(regionData);
  }

  private createHolesPath(regionData: IRegionModelData) {
    const holes: IPoint2d[][] = [];
    for (const holeInfo of regionData.coreHoleInfos) {
      let holePath: IPoint2d[] = [];
      for (const holeEdge of holeInfo) {
        // 弧形开洞采样点
        if (isArc(holeEdge)) {
          const arc = new ArcSeg2d({
            start: holeEdge.start,
            end: holeEdge.end,
            center: holeEdge.center,
            clockwise: holeEdge.clockwise
          });
          const arcPoints = arc.getPoints();
          holePath = holePath.concat(arcPoints);
        } else {
          holePath.push(holeEdge.start);
        }
      }

      holes.push(holePath);
    }

    return holes;
  }

  createRegionModel(regionData: IRegionModelData) {
    super.createModel(
      {
        id: regionData.id,
        materialInfo: regionData.materialInfo,
        type: EFaceType.RegionFace,
        baseData: translateRegionToBaseData(regionData),
        baseDataType: EFaceDataBaseType.Contour,
        relativeInfo: {
          side: EFaceSide.TopSide
        }
      },
      this.createHolesPath(regionData)
    );
  }
}

export default RegionModel;
